/*
 * Copyright (C) 2023 Das Land Schleswig-Holstein vertreten durch den
 * Ministerpräsidenten des Landes Schleswig-Holstein
 * Staatskanzlei
 * Abteilung Digitalisierung und zentrales IT-Management der Landesregierung
 *
 * Lizenziert unter der EUPL, Version 1.2 oder - sobald
 * diese von der Europäischen Kommission genehmigt wurden -
 * Folgeversionen der EUPL ("Lizenz");
 * Sie dürfen dieses Werk ausschließlich gemäß
 * dieser Lizenz nutzen.
 * Eine Kopie der Lizenz finden Sie hier:
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Sofern nicht durch anwendbare Rechtsvorschriften
 * gefordert oder in schriftlicher Form vereinbart, wird
 * die unter der Lizenz verbreitete Software "so wie sie
 * ist", OHNE JEGLICHE GEWÄHRLEISTUNG ODER BEDINGUNGEN -
 * ausdrücklich oder stillschweigend - verbreitet.
 * Die sprachspezifischen Genehmigungen und Beschränkungen
 * unter der Lizenz sind dem Lizenztext zu entnehmen.
 */
import { UserProfileService } from '@alfa-client/user-profile-shared';
import { VorgangHeaderLinkRel, VorgangWithEingangResource } from '@alfa-client/vorgang-shared';
import { Component, inject, Input } from '@angular/core';

@Component({
  selector: 'alfa-assign-user-profile-button-container',
  templateUrl: './assign-user-profile-button-container.component.html',
  host: { class: 'empty:hidden' },
  standalone: false,
})
export class AssignUserProfileButtonContainerComponent {
  private readonly service = inject(UserProfileService);

  @Input() vorgang: VorgangWithEingangResource;

  readonly linkRel = VorgangHeaderLinkRel;

  public showUserProfileSearch(e: MouseEvent): void {
    e.stopPropagation();
    document.documentElement.scrollTop = 0;
    this.service.openDropdown();
  }
}
